import { AnyAction } from 'redux';
import { HomeAccessActions } from '../action/HomeAccessActionTypes';

export interface IHomeAccess {
  dashboard: boolean;
  project_manager: boolean;
  integration_manager: boolean;
  bi: boolean;
  integration_dashboard: boolean;
}

/**
 * Estado de los accesos a los productos de Wholemeaning
 */
export interface IHomeState {
  access: IHomeAccess;
  errorCode: string;
  error: boolean;
  load: boolean;
}

const initialState: IHomeState = {
  access: {
    dashboard: false,
    project_manager: false,
    integration_manager: false,
    bi: false,
    integration_dashboard: false,
  },
  load: false,
  error: false,
  errorCode: '',
};

const setNewProductAccess = (state: IHomeState, newAccess: IHomeAccess) => ({
  ...state,
  access: newAccess,
});

const setError = (state: IHomeState, error: boolean) => ({
  ...state,
  error,
});

const setErrorCode = (state: IHomeState, errorCode: string) => ({
  ...state,
  errorCode,
});

const setLoading = (state: IHomeState, load: boolean) => ({
  ...state,
  load,
});

/**
 * Reducer del componente de home
 * @param state Estado de la aplicacion
 * @param action Acción que fue disparada por la aplicacion
 * @returns Nuevo estado luego del cambio
 */
export const HomeReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case HomeAccessActions.Load:
      return setLoading(state, action.load);
    case HomeAccessActions.Error:
      return setError(state, action.error);
    case HomeAccessActions.ErrorMessage:
      return setErrorCode(state, action.message);
    case HomeAccessActions.Access:
      return setNewProductAccess(state, action.access);
    default:
      return state;
  }
};
